export default __webpack_public_path__ + "static/media/calendar.82df0976.svg";